import { useState } from "react";
import CustomModal from "../../components/Modals/CustomModal.jsx";
import "../../styles/Tabs.css";

const Tabs = ({ activeTab, onChange, clientInfo }) => {
  
  const [showClientAlert, setShowClientAlert] = useState(false);

  return (
    <div className="tabs-wrapper">
      <div className="tabs">
        <button
          className={`tab-button ${
            activeTab === "companySelect" ? "active" : ""
          }`}
          onClick={() => onChange("companySelect")}
        >
          거래처 검색
        </button>
        <button
          className={`tab-button ${
            activeTab === "passwordInit" ? "active" : ""
          }`}
          onClick={() => {
            if (!clientInfo || clientInfo.length === 0) {
              setShowClientAlert(true);
              return;
            }
            onChange("passwordInit");
          }}
        >
          비밀번호 초기화
        </button>
      </div>

      <CustomModal
        show={showClientAlert}
        onHide={() => setShowClientAlert(false)}
        onConfirm={() => setShowClientAlert(false)}
        width={400}
        height={200}
        message="거래처를 먼저 선택해주세요."
        confirmText="확인"
        cancelText=""
      />
    </div>
  );
};

export default Tabs;
